module.exports = __webpack_public_path__ + "static/img/digital-health-solutions-his-1.0ecd16c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/digital-health-solutions-his-1.png
// module id = HRAU
// module chunks = 2